import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

function Catalog() {
  const [drops, setDrops] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchCatalog() {
      try {
        const res = await fetch(`${process.env.REACT_APP_WORKER_URL}/catalog`);
        if (!res.ok) throw new Error(`Failed to load catalog (${res.status})`);
        const data = await res.json();
        setDrops(data.drops);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    }
    fetchCatalog();
  }, []);

  if (loading) return <main><p>Loading drops…</p></main>;
  if (error) return <main><p style={{ color: 'red' }}>Error: {error}</p></main>;

  return (
    <main>
      <h1>Catalog</h1>
      <p>Browse available drops.</p>
      {drops.map(drop => {
        var soldOut = drop.status === 'Sold Out';
        var comingSoon = drop.status === 'Coming Soon';
        var inactive = soldOut || comingSoon;
        return (
          <div key={drop.id} style={{ opacity: inactive ? 0.6 : 1 }}>
            <h2>
              {drop.name}
              {soldOut && (
                <span style={{
                  marginLeft: '12px',
                  fontSize: '11px',
                  letterSpacing: '0.15em',
                  textTransform: 'uppercase',
                  color: '#888',
                  border: '1px solid #444',
                  padding: '2px 8px',
                  borderRadius: '2px',
                  verticalAlign: 'middle',
                }}>
                  Sold Out
                </span>
              )}
              {comingSoon && (
                <span style={{
                  marginLeft: '12px',
                  fontSize: '11px',
                  letterSpacing: '0.15em',
                  textTransform: 'uppercase',
                  color: '#c8f55a',
                  border: '1px solid #c8f55a44',
                  padding: '2px 8px',
                  borderRadius: '2px',
                  verticalAlign: 'middle',
                }}>
                  Coming Soon
                </span>
              )}
            </h2>
            {drop.tagline && <p>{drop.tagline}</p>}
            <p>Units: {drop.unitCount} — ${drop.dropPrice?.toLocaleString()}</p>
            {soldOut && <span style={{ color: '#555', fontSize: '13px' }}>This drop is closed.</span>}
            {comingSoon && <span style={{ color: '#555', fontSize: '13px' }}>Available soon.</span>}
            {!inactive && <Link to={`/drop/${drop.slug}`}>View Drop →</Link>}
          </div>
        );
      })}
    </main>
  );
}

export default Catalog;